import { render, staticRenderFns } from "./Inspection2.vue?vue&type=template&id=517c0b6b&scoped=true&"
import script from "./Inspection2.vue?vue&type=script&lang=js&"
export * from "./Inspection2.vue?vue&type=script&lang=js&"
import style0 from "./Inspection2.vue?vue&type=style&index=0&id=517c0b6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c0b6b",
  null
  
)

export default component.exports